import { css } from '@compiled/react';
import { useIntl } from 'react-intl';

const disclaimerTextStyles = css({
	fontWeight: '400px',
	lineHeight: '20px',
	fontSize: '14px',
	color: '#000000',
	paddingBlockStart: '24px',
});

const Disclaimer = ({ disclaimerText }: { disclaimerText?: string }) => {
	const intl = useIntl();
	const text =
		disclaimerText ??
		intl.formatMessage({
			id: 'pricing.disclaimer.text',
			defaultMessage:
				"The prices shown are estimates and aren't binding for either you or Atlassian. The amount you are billed may be different if you change your scope of use, including by updating your agent count or exceeding your base plan usage of Assets or Virtual Service Agent.",
		});
	return <p css={disclaimerTextStyles}>{text}</p>;
};

Disclaimer.displayName = 'disclaimer';
export default Disclaimer;
